module.exports = __webpack_public_path__ + "img/banner-Mobile.66bbfbb1.png";